export interface VerifierRecord {
  verifier: string;
  nonce: string;
}

export interface VerifierStore {
  put: (record: VerifierRecord) => void;
  take: () => VerifierRecord | null;
}

export const STORAGE_KEY = 'ams-auth-pkce';

export const verifierStore: VerifierStore = {
  put(record) {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(record));
  },
  take() {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return null;
    }
    sessionStorage.removeItem(STORAGE_KEY);
    try {
      return JSON.parse(raw) as VerifierRecord;
    } catch {
      return null;
    }
  },
};
